"use client"

import {
    AppBar,
    Button,
    Dialog,
    DialogContent,
    Divider,
    IconButton,
    Slide,
    Toolbar,
    Typography,
    Box,
    Avatar,
    Chip,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Paper,
    Container,
    TextField,
    DialogTitle,
    DialogActions,
    FormControlLabel,
    Switch,
} from "@mui/material"
import {
    Close as CloseIcon,
    Email as EmailIcon,
    Phone as PhoneIcon,
    Work as WorkIcon,
    School as SchoolIcon,
    LocationOn as LocationIcon,
    LinkedIn as LinkedInIcon,
    Twitter as TwitterIcon,
    CalendarToday as CalendarIcon,
    Business as BusinessIcon,
    Person as PersonIcon,
    PersonAdd as PersonAddIcon,
    GitHub,
    Share,
    WorkOutline,
    Info,
    SchoolOutlined,
    Code,
    Edit,
} from "@mui/icons-material"
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { openSnackbar } from "store/slices/snackbar"
import useRequestIdGenerater from "customhooks"
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp"
import axios from "axios"
import NoAvailableData from "reuseableTable/NoAvailableData"
import MenteeList from "./MenteeList"
import AnimatedLoader from "reuseableTable/AnimatedLoader"

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const MentorDetails = ({
    showMentorProfile,
    setShowMentorProfile,
    mentorData,
    getMentorDetails,
    loadingMentorProfile,
    setMentorResponseData,
    currentUserId
}) => {
    const mentorDetails = mentorData?.alumniMember
    const mentee = mentorData?.mentee
    const dispatch = useDispatch()


    const [editingAreas, setEditingAreas] = useState(false);
    const [editingInfo, setEditingInfo] = useState(false);
    const [newArea, setNewArea] = useState('');
    const [infoText, setInfoText] = useState(mentorData?.mentor?.mentorshipInfo || '');

    const RequestId = useRequestIdGenerater()
    const { rendomRequestId, generateTimeStamp } = useTimeStamp()


    const [showReasonDialog, setShowReasonDialog] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isMentor, setIsMentor] = useState(false)
    const [reason, setReason] = useState('')
    const formatDate = (dateString) => {
        if (!dateString) return "Present"
        return new Date(dateString).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
        })
    }
    const getSocialIcon = (type) => {
        switch (type?.toLowerCase()) {
            case "linkedin":
                return <LinkedInIcon />
            case "twitter":
                return <TwitterIcon />
            default:
                return <PersonIcon />
        }
    }

    const validWorkDetails =
        mentorDetails?.workingDetails?.filter((work) => work.organizationName && work.organizationName.trim() !== "") || []

    const validEducationDetails =
        mentorDetails?.educationDetails?.filter((edu) => edu.instituteName && edu.instituteName.trim() !== "") || []

    const handleJoinAsMentee = () => {
        setShowReasonDialog(true)
    }

    const onJoinAsMentee = (mentorAlumniId) => {
        const payload = {
            reason: reason,
        }
        axios
            .post(
                `/v1/mentorship/request-for-mentor?mentorAlumniId=${mentorAlumniId}`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
                        "Content-Type": "application/json",
                        requestId: RequestId(
                            Math.floor(1000 + Math.random() * 9999),
                            Math.floor(1000 + Math.random() * 9999 + rendomRequestId),
                        ),
                    },
                },
            )
            .then((value) => {
                setMentorResponseData((prev) => ({
                    ...prev,
                    mentee: value?.data?.data,
                }))
                dispatch(
                    openSnackbar({
                        open: true,
                        message: value.data.Msg || "Mentor application submitted successfully!",
                        variant: "alert",
                        alert: {
                            color: "success",
                        },
                        close: false,
                    }),
                )
                setIsSubmitting(false)
                generateTimeStamp()
            })
            .catch((error) => {
                setIsSubmitting(false)
                generateTimeStamp()

                const message = error.response?.data?.Msg || (error.response?.status === 404 ? "Service not found" : "Something went wrong")
                const color = error.response?.status === 404 ? "error" : "error"

                dispatch(
                    openSnackbar({
                        open: true,
                        message: message,
                        variant: "alert",
                        alert: {
                            color: color,
                        },
                        close: false,
                    }),
                )
            })
    }
    const handleChangeMentorStatus = (newStatus) => {
        axios
            .put(
                `/v1/mentorship/update-mentor-status`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
                        "Content-Type": "application/json",
                        requestId: RequestId(
                            Math.floor(1000 + Math.random() * 9999),
                            Math.floor(1000 + Math.random() * 9999 + rendomRequestId),
                        ),
                    },
                },
            )
            .then((value) => {
                const key = mentorDetails?.alumniMember?.mentor;

                setMentorResponseData((prev) => ({
                    ...prev,
                    active: newStatus,
                }));

                dispatch(
                    openSnackbar({
                        open: true,
                        message: value.data.Msg || "Status Updated Successfully!",
                        variant: "alert",
                        alert: {
                            color: "success",
                        },
                        close: false,
                    }),
                )
                setIsSubmitting(false)
                generateTimeStamp()
            })
            .catch((error) => {
                setIsSubmitting(false)
                generateTimeStamp()

                const message = error.response?.data?.Msg || (error.response?.status === 404 ? "Service not found" : "Something went wrong")
                const color = error.response?.status === 404 ? "error" : "error"

                dispatch(
                    openSnackbar({
                        open: true,
                        message: message,
                        variant: "alert",
                        alert: {
                            color: color,
                        },
                        close: false,
                    }),
                )
            })
    }
    const handleSubmitReason = () => {
        if (!reason.trim()) {
            dispatch(
                openSnackbar({
                    open: true,
                    message: "Please provide a reason for wanting a mentor",
                    variant: "alert",
                    alert: {
                        color: "warning",
                    },
                    close: false,
                }),
            )
            return
        }
        setIsSubmitting(true)
        setShowReasonDialog(false)
        onJoinAsMentee(mentorDetails?.id)
    }
    const handleCloseReasonDialog = () => {
        setShowReasonDialog(false)
        setReason("")
    }
    useEffect(() => {
        if (mentorDetails?.id === localStorage.getItem('alumniId')) {
            setIsMentor(true)
        } else {
            setIsMentor(false)
        }
    }, [mentorData])
    const handleDeleteArea = (areaToDelete) => {
        const updatedAreas = mentorData?.mentor?.areaOffers.filter(area => area !== areaToDelete);
        axios
            .put(
                `/v1/mentorship/mentor-detail-update`,
                {
                    areaOffers: updatedAreas,
                    mentorshipInfo: infoText
                },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
                        "Content-Type": "application/json",
                        requestId: RequestId(
                            Math.floor(1000 + Math.random() * 9999),
                            Math.floor(1000 + Math.random() * 9999 + rendomRequestId),
                        ),
                    },
                },
            )
            .then((value) => {
                setMentorResponseData(prev => ({
                    ...prev,
                    mentor: {
                        ...prev.mentor,
                        areaOffers: updatedAreas
                    }
                }));

                dispatch(
                    openSnackbar({
                        open: true,
                        message: value.data.Msg || "Status Updated Successfully!",
                        variant: "alert",
                        alert: {
                            color: "success",
                        },
                        close: false,
                    }),
                )
                setIsSubmitting(false)
                generateTimeStamp()
            })
            .catch((error) => {
                setIsSubmitting(false)
                generateTimeStamp()

                const message = error.response?.data?.Msg || (error.response?.status === 404 ? "Service not found" : "Something went wrong")
                const color = error.response?.status === 404 ? "error" : "error"

                dispatch(
                    openSnackbar({
                        open: true,
                        message: message,
                        variant: "alert",
                        alert: {
                            color: color,
                        },
                        close: false,
                    }),
                )
            })

    };
    return (
        <>
            <Dialog
                fullScreen
                open={showMentorProfile}
                onClose={() => setShowMentorProfile(false)}
                sx={{ p: 0 }}
            >
                <AppBar sx={{
                    position: "absolute",
                    backgroundColor: '#028943',
                    color: 'white',
                    boxShadow: 'none'
                }}>
                    <Toolbar>
                        <Typography color='inherit' sx={{ ml: 2, flex: 1 }} variant="h6">
                            {mentorDetails?.name.toUpperCase() || "Mentor Profile"}
                        </Typography>
                        <Button
                            autoFocus
                            color="inherit"
                            onClick={() => setShowMentorProfile(false)}
                            sx={{
                                '&:hover': {
                                    backgroundColor: 'rgba(255,255,255,0.1)'
                                }
                            }}
                        >
                            Close
                        </Button>
                    </Toolbar>
                </AppBar>

                <DialogContent sx={{ p: 0, mt: 5 }}>
                    <Grid sx={{ p: 3 }}>
                        {isMentor ? (
                            <Grid sx={{ mt: 3 }}>
                                <Grid container alignItems="center" sx={{
                                    p: 4,
                                    mb: 4,
                                    transition: "all 0.3s ease-in-out",
                                    "&:hover": {
                                        transform: "translateY(-4px)",
                                        boxShadow: 6,
                                    },
                                    borderRadius: 2,
                                    mt: 4,
                                    // backgroundColor: 'white',
                                    border: '1px solid gray'
                                }}>
                                    <Grid item>
                                        <Avatar
                                            src={
                                                mentorDetails?.avatar?.data
                                                    ? `data:image/*;base64,${mentorDetails.avatar.data}`
                                                    : mentorDetails?.largeAvatar
                                                        ? `/avatar/${mentorDetails.largeAvatar}`
                                                        : undefined
                                            }
                                            sx={{
                                                width: 120,
                                                height: 120,
                                                fontSize: "2rem",
                                                fontWeight: 600,
                                                bgcolor: '#028943',
                                                color: 'white'
                                            }}
                                        >
                                            {mentorDetails?.name
                                                ?.split(" ")
                                                .map((n) => n[0])
                                                .join("")
                                                .toUpperCase()}
                                        </Avatar>
                                        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600, color: '#333', mt: 1 }}>
                                            {mentorDetails?.name}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs>
                                        <Box sx={{ mb: 2, ml: 1 }}>
                                            {/* Switch */}
                                            <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={mentorData?.active}
                                                            onChange={(e) => {
                                                                const checked = e.target.checked;
                                                                handleChangeMentorStatus(checked);
                                                            }}
                                                            color="primary"
                                                            sx={{
                                                                '& .MuiSwitch-thumb': { color: '#028943' },
                                                                '& .Mui-checked .MuiSwitch-thumb': { color: '#028943' },
                                                                '& .MuiSwitch-track': { backgroundColor: '#028943 !important', opacity: 0.5 },
                                                            }}
                                                        />
                                                    }
                                                    label="Disable your Account"
                                                    sx={{ color: '#028943' }}
                                                />
                                            </Box>

                                            {/* Area Offers Section */}
                                            <Box sx={{ mb: 2 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Expertise Areas</Typography>
                                                    <IconButton onClick={() => setEditingAreas(!editingAreas)}><Edit /></IconButton>
                                                </Box>
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                                                    {mentorData?.mentor?.areaOffers?.map((data, index) => (
                                                        <Chip
                                                            key={index}
                                                            label={data}
                                                            onDelete={editingAreas ? () => handleDeleteArea(data) : undefined}
                                                        />
                                                    ))}
                                                </Box>

                                                {editingAreas && (
                                                    <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                                                        <TextField
                                                            size="small"
                                                            value={newArea}
                                                            onChange={(e) => setNewArea(e.target.value)}
                                                            placeholder="Add new area"
                                                        />
                                                        <Button
                                                            onClick={() => {
                                                                if (newArea.trim() === '') return;
                                                                const updatedAreas = [...mentorData?.mentor?.areaOffers ?? "", newArea.trim()];
                                                                axios.put(`/v1/mentorship/mentor-detail-update`, {
                                                                    areaOffers: updatedAreas,
                                                                    mentorshipInfo: mentorData?.mentor?.mentorshipInfo,
                                                                }, {
                                                                    headers: {
                                                                        Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
                                                                        "Content-Type": "application/json",
                                                                        requestId: RequestId(
                                                                            Math.floor(1000 + Math.random() * 9999),
                                                                            Math.floor(1000 + Math.random() * 9999 + rendomRequestId),
                                                                        ),
                                                                    }
                                                                }).then(response => {
                                                                    setMentorResponseData(prev => ({
                                                                        ...prev,
                                                                        mentor: {
                                                                            ...prev.mentor,
                                                                            areaOffers: updatedAreas
                                                                        }
                                                                    }));
                                                                    setNewArea('');
                                                                    dispatch(openSnackbar({
                                                                        open: true,
                                                                        message: response.data.Msg || "Area added successfully!",
                                                                        variant: "alert",
                                                                        alert: { color: "success" },
                                                                        close: false,
                                                                    }));
                                                                }).catch(error => {
                                                                    dispatch(openSnackbar({
                                                                        open: true,
                                                                        message: error.response?.data?.Msg || "Failed to add area.",
                                                                        variant: "alert",
                                                                        alert: { color: "error" },
                                                                        close: false,
                                                                    }));
                                                                });
                                                            }}
                                                            variant="contained"
                                                            size="small"
                                                        >
                                                            Add
                                                        </Button>
                                                    </Box>
                                                )}
                                            </Box>

                                            {/* Mentorship Info Section */}
                                            <Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Mentorship Info</Typography>
                                                    <IconButton onClick={() => setEditingInfo(!editingInfo)}><Edit /></IconButton>
                                                </Box>
                                                {editingInfo ? (
                                                    <Box sx={{ mt: 1 }}>
                                                        <TextField
                                                            multiline
                                                            rows={3}
                                                            fullWidth
                                                            value={infoText}
                                                            onChange={(e) => setInfoText(e.target.value)}
                                                        />
                                                        <Button
                                                            onClick={() => {
                                                                axios.put(`/v1/mentorship/mentor-detail-update`, {
                                                                    areaOffers: mentorData?.mentor?.areaOffers,
                                                                    mentorshipInfo: infoText
                                                                }, {
                                                                    headers: {
                                                                        Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
                                                                        "Content-Type": "application/json",
                                                                        requestId: RequestId(
                                                                            Math.floor(1000 + Math.random() * 9999),
                                                                            Math.floor(1000 + Math.random() * 9999 + rendomRequestId),
                                                                        ),
                                                                    }
                                                                }).then(response => {
                                                                    setMentorResponseData(prev => ({
                                                                        ...prev,
                                                                        mentor: {
                                                                            ...prev.mentor,
                                                                            mentorshipInfo: infoText
                                                                        }
                                                                    }));
                                                                    setEditingInfo(false);
                                                                    dispatch(openSnackbar({
                                                                        open: true,
                                                                        message: response.data.Msg || "Information updated successfully!",
                                                                        variant: "alert",
                                                                        alert: { color: "success" },
                                                                        close: false,
                                                                    }));
                                                                }).catch(error => {
                                                                    dispatch(openSnackbar({
                                                                        open: true,
                                                                        message: error.response?.data?.Msg || "Failed to update info.",
                                                                        variant: "alert",
                                                                        alert: { color: "error" },
                                                                        close: false,
                                                                    }));
                                                                });
                                                            }}
                                                            variant="contained"
                                                            size="small"
                                                            sx={{ mt: 1 }}
                                                        >
                                                            Save
                                                        </Button>
                                                    </Box>
                                                ) : (
                                                    <Typography sx={{ mt: 1 }}>
                                                        {mentorData?.mentor?.mentorshipInfo?.trim()
                                                            ? mentorData?.mentor?.mentorshipInfo
                                                            : "No additional information provided."}
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Box>



                                    </Grid>
                                </Grid>
                                <MenteeList />
                            </Grid>
                        ) : (
                            <>
                                {loadingMentorProfile ? (
                                    <>
                                        <AnimatedLoader />
                                    </>
                                ) : (
                                    <>
                                        <Paper elevation={2} sx={{
                                            p: 4,
                                            mb: 4,
                                            transition: "all 0.3s ease-in-out",
                                            "&:hover": {
                                                transform: "translateY(-4px)",
                                                boxShadow: 6,
                                            },
                                            borderRadius: 2,
                                            mt: 4,
                                            // backgroundColor: 'white',
                                            border: '1px solid gray'
                                        }}>
                                            <Grid container alignItems="center">
                                                <Grid item>
                                                    <Avatar
                                                        src={
                                                            mentorDetails?.avatar?.data
                                                                ? `data:image/*;base64,${mentorDetails.avatar.data}`
                                                                : mentorDetails?.largeAvatar
                                                                    ? `/avatar/${mentorDetails.largeAvatar}`
                                                                    : undefined
                                                        }
                                                        sx={{
                                                            width: 120,
                                                            height: 120,
                                                            fontSize: "2rem",
                                                            fontWeight: 600,
                                                            bgcolor: '#028943',
                                                            color: 'white'
                                                        }}
                                                    >
                                                        {mentorDetails?.name
                                                            ?.split(" ")
                                                            .map((n) => n[0])
                                                            .join("")
                                                            .toUpperCase()}
                                                    </Avatar>
                                                </Grid>
                                                <Grid item xs>
                                                    <Box sx={{ mb: 2, ml: 1 }}>
                                                        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600, color: '#333' }}>
                                                            {mentorDetails?.name}
                                                        </Typography>
                                                        <Typography variant="h6" color="#666" gutterBottom>
                                                            {mentorDetails?.careerStatus?.replace("_", " ")}
                                                        </Typography>
                                                        <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                                                            <Chip
                                                                label={`Batch ${mentorDetails?.batch?.tag}`}
                                                                sx={{
                                                                    backgroundColor: '#e8f5e9',
                                                                    color: '#028943',
                                                                    fontWeight: 500,
                                                                    border: 'none'
                                                                }}
                                                            />
                                                            <Chip
                                                                label={mentorDetails?.programs?.name}
                                                                sx={{
                                                                    backgroundColor: '#e8f5e9',
                                                                    color: '#028943',
                                                                    fontWeight: 500,
                                                                    border: 'none'
                                                                }}
                                                            />
                                                        </Box>
                                                    </Box>
                                                    {!isMentor ? (
                                                        <>
                                                            {!mentee ? (
                                                                <>
                                                                    <Button
                                                                        variant="contained"
                                                                        size="small"
                                                                        startIcon={<PersonAddIcon />}
                                                                        onClick={handleJoinAsMentee}
                                                                        disabled={isSubmitting}
                                                                        sx={{
                                                                            borderRadius: 2,
                                                                            textTransform: "none",
                                                                            fontWeight: 600,
                                                                            px: 3,
                                                                            backgroundColor: '#028943',
                                                                            '&:hover': {
                                                                                backgroundColor: '#026f35'
                                                                            }
                                                                        }}
                                                                    >
                                                                        {isSubmitting ? "Submitting..." : "Request Mentorship"}
                                                                    </Button>
                                                                </>
                                                            ) : (
                                                                <Chip
                                                                    label={`Your mentee request is ${mentee?.approvalStatus}`}
                                                                    sx={{
                                                                        fontWeight: 500,
                                                                        backgroundColor:
                                                                            mentee?.approvalStatus === "Approved"
                                                                                ? '#e8f5e9'
                                                                                : mentee?.approvalStatus === "Pending"
                                                                                    ? '#fff8e1'
                                                                                    : '#f5f5f5',
                                                                        color:
                                                                            mentee?.approvalStatus === "Approved"
                                                                                ? '#028943'
                                                                                : mentee?.approvalStatus === "Pending"
                                                                                    ? '#ff8f00'
                                                                                    : '#666',
                                                                        border: '1px solid',
                                                                        borderColor:
                                                                            mentee?.approvalStatus === "Approved"
                                                                                ? '#c8e6c9'
                                                                                : mentee?.approvalStatus === "Pending"
                                                                                    ? '#ffe0b2'
                                                                                    : '#e0e0e0'
                                                                    }}
                                                                />
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                        </>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                        <Grid container spacing={4}>
                                            <Grid item xs={12} md={8}>
                                                {mentorDetails?.aboutMe && (
                                                    <Paper elevation={1} sx={{
                                                        p: 3,
                                                        mb: 3,
                                                        borderRadius: 2,
                                                        transition: "all 0.3s ease-in-out",
                                                        "&:hover": {
                                                            transform: "translateY(-4px)",
                                                            boxShadow: 6,
                                                        },
                                                        border: '1px solid gray'
                                                    }}>
                                                        <Typography variant="h6" gutterBottom sx={{
                                                            fontWeight: 600,
                                                            color: '#028943',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 1
                                                        }}>
                                                            <Info sx={{ color: '#028943' }} />
                                                            About Me
                                                        </Typography>
                                                        <Typography variant="body1" sx={{ lineHeight: 1.6, color: '#666' }}>
                                                            {mentorDetails.aboutMe}
                                                        </Typography>
                                                    </Paper>
                                                )}

                                                {/* Work Experience */}
                                                {validWorkDetails.length > 0 && (
                                                    <Paper elevation={1} sx={{
                                                        p: 3,
                                                        mb: 3,
                                                        borderRadius: 2,
                                                        transition: "all 0.3s ease-in-out",
                                                        "&:hover": {
                                                            transform: "translateY(-4px)",
                                                            boxShadow: 6,
                                                        },
                                                        border: '1px solid gray'
                                                    }}>
                                                        <Typography variant="h6" gutterBottom sx={{
                                                            fontWeight: 600,
                                                            color: '#028943',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 1
                                                        }}>
                                                            <WorkIcon sx={{ color: '#028943' }} />
                                                            Work Experience
                                                        </Typography>
                                                        <List sx={{ p: 0 }}>
                                                            {validWorkDetails?.map((work, index) => (
                                                                <React.Fragment key={work.id || index}>
                                                                    <ListItem sx={{ px: 0, py: 2 }}>
                                                                        <ListItemIcon>
                                                                            <WorkOutline sx={{ color: '#028943' }} />
                                                                        </ListItemIcon>
                                                                        <ListItemText
                                                                            primary={
                                                                                <Box>
                                                                                    <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#333' }}>
                                                                                        {work.designation || "Position"}
                                                                                    </Typography>
                                                                                    <Typography variant="body2" sx={{ fontWeight: 500, color: '#028943' }}>
                                                                                        {work.organizationName}
                                                                                    </Typography>
                                                                                </Box>
                                                                            }
                                                                            secondary={
                                                                                <Box sx={{ mt: 1 }}>
                                                                                    <Typography variant="body2" color="#757575">
                                                                                        {work.startMonth && work.startYear
                                                                                            ? `${work.startMonth}/${work.startYear}`
                                                                                            : formatDate(work.joiningDate)}{" "}
                                                                                        -{" "}
                                                                                        {work.present
                                                                                            ? "Present"
                                                                                            : work.endMonth && work.endYear
                                                                                                ? `${work.endMonth}/${work.endYear}`
                                                                                                : formatDate(work.endDate)}
                                                                                    </Typography>
                                                                                    {/* {work.yearOfExperience > 0 && (
                                                                                        <Typography variant="body2" color="#757575">
                                                                                            {work.yearOfExperience} years experience
                                                                                        </Typography>
                                                                                    )} */}
                                                                                    {work.functionalArea && (
                                                                                        <Chip
                                                                                            label={work.functionalArea}
                                                                                            size="small"
                                                                                            sx={{
                                                                                                backgroundColor: '#e8f5e9',
                                                                                                color: '#028943',
                                                                                                fontWeight: 500,
                                                                                                mt: 1,
                                                                                                mr: 1,
                                                                                                border: 'none'
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                    {work.industries && (
                                                                                        <Chip
                                                                                            label={work.industries}
                                                                                            size="small"
                                                                                            sx={{
                                                                                                backgroundColor: '#e8f5e9',
                                                                                                color: '#028943',
                                                                                                fontWeight: 500,
                                                                                                mt: 1,
                                                                                                border: 'none'
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                    {work.detailRole && (
                                                                                        <Typography variant="body2" sx={{ mt: 1, color: '#666' }}>
                                                                                            {work.detailRole}
                                                                                        </Typography>
                                                                                    )}
                                                                                </Box>
                                                                            }
                                                                        />
                                                                    </ListItem>
                                                                    {index < validWorkDetails.length - 1 && <Divider sx={{ borderColor: '#e0e0e0' }} />}
                                                                </React.Fragment>
                                                            ))}
                                                        </List>
                                                    </Paper>
                                                )}

                                                {/* Education */}
                                                {validEducationDetails.length > 0 && (
                                                    <Paper elevation={1} sx={{
                                                        p: 3,
                                                        mb: 3,
                                                        borderRadius: 2,
                                                        transition: "all 0.3s ease-in-out",
                                                        "&:hover": {
                                                            transform: "translateY(-4px)",
                                                            boxShadow: 6,
                                                        },
                                                        border: '1px solid gray'
                                                    }}>
                                                        <Typography variant="h6" gutterBottom sx={{
                                                            fontWeight: 600,
                                                            color: '#028943',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 1
                                                        }}>
                                                            <SchoolIcon sx={{ color: '#028943' }} />
                                                            Education
                                                        </Typography>
                                                        <List sx={{ p: 0 }}>
                                                            {validEducationDetails.map((edu, index) => (
                                                                <React.Fragment key={edu.id || index}>
                                                                    <ListItem sx={{ px: 0, py: 2 }}>
                                                                        <ListItemIcon>
                                                                            <SchoolOutlined sx={{ color: '#028943' }} />
                                                                        </ListItemIcon>
                                                                        <ListItemText
                                                                            primary={
                                                                                <Box>
                                                                                    <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#333' }}>
                                                                                        {edu.courseName || edu.educationLevel?.replace("_", " ")}
                                                                                    </Typography>
                                                                                    <Typography variant="body2" sx={{ fontWeight: 500, color: '#028943' }}>
                                                                                        {edu.instituteName}
                                                                                    </Typography>
                                                                                </Box>
                                                                            }
                                                                            secondary={
                                                                                <Box sx={{ mt: 1 }}>
                                                                                    {edu.affiliation && (
                                                                                        <Typography variant="body2" color="#757575">
                                                                                            Affiliated to: {edu.affiliation}
                                                                                        </Typography>
                                                                                    )}
                                                                                    {(edu.startYear || edu.endYear) && (
                                                                                        <Typography variant="body2" color="#757575">
                                                                                            {edu.startYear && `${edu.startYear} - `}
                                                                                            {edu.endYear || "Present"}
                                                                                        </Typography>
                                                                                    )}
                                                                                </Box>
                                                                            }
                                                                        />
                                                                    </ListItem>
                                                                    {index < validEducationDetails.length - 1 && <Divider sx={{ borderColor: '#e0e0e0' }} />}
                                                                </React.Fragment>
                                                            ))}
                                                        </List>
                                                    </Paper>
                                                )}
                                            </Grid>

                                            {/* Right Column */}
                                            <Grid item xs={12} md={4}>
                                                {/* Expertise Section - Added based on your image */}
                                                {mentorDetails?.areasOfExpertise?.length > 0 && (
                                                    <Paper elevation={1} sx={{
                                                        p: 3,
                                                        mb: 3,
                                                        borderRadius: 2,
                                                        backgroundColor: 'white',
                                                        border: '1px solid #e0e0e0'
                                                    }}>
                                                        <Typography variant="h6" gutterBottom sx={{
                                                            fontWeight: 600,
                                                            color: '#028943',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 1
                                                        }}>
                                                            <Code sx={{ color: '#028943' }} />
                                                            Areas of Expertise
                                                        </Typography>
                                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                                            {mentorDetails?.areasOfExpertise?.map((expertise, index) => (
                                                                <Chip
                                                                    label={expertise}
                                                                    sx={{
                                                                        backgroundColor: '#e8f5e9',
                                                                        color: '#028943',
                                                                        fontWeight: 500,
                                                                        border: 'none'
                                                                    }}
                                                                />
                                                            ))}
                                                        </Box>
                                                    </Paper>
                                                )}

                                                {/* Social Links */}
                                                {mentorDetails?.socialLinks?.length > 0 && (
                                                    <Paper elevation={1} sx={{
                                                        p: 3,
                                                        mb: 3,
                                                        borderRadius: 2,
                                                        transition: "all 0.3s ease-in-out",
                                                        "&:hover": {
                                                            transform: "translateY(-4px)",
                                                            boxShadow: 6,
                                                        },
                                                        border: '1px solid gray'
                                                    }}>
                                                        <Typography variant="h6" gutterBottom sx={{
                                                            fontWeight: 600,
                                                            color: '#028943',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 1
                                                        }}>
                                                            <Share sx={{ color: '#028943' }} />
                                                            Social Links
                                                        </Typography>
                                                        <List sx={{ p: 0 }}>
                                                            {mentorDetails?.socialLinks?.map((social, index) => (
                                                                <ListItem key={index} sx={{ px: 0, py: 1 }}>
                                                                    <ListItemIcon sx={{ minWidth: 40 }}>
                                                                        {getSocialIcon(social.socialLinkType)}
                                                                    </ListItemIcon>
                                                                    <ListItemText
                                                                        primary={
                                                                            <Button
                                                                                href={social.socialLink}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                sx={{
                                                                                    textTransform: "none",
                                                                                    p: 0,
                                                                                    justifyContent: "flex-start",
                                                                                    color: '#028943',
                                                                                    fontWeight: 500,
                                                                                    '&:hover': {
                                                                                        textDecoration: 'underline',
                                                                                        backgroundColor: 'transparent'
                                                                                    }
                                                                                }}
                                                                            >
                                                                                {social.socialLinkType}
                                                                            </Button>
                                                                        }
                                                                    />
                                                                </ListItem>
                                                            ))}
                                                        </List>
                                                    </Paper>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </>
                                )}
                            </>
                        )}
                    </Grid>
                </DialogContent>
                <Dialog
                    open={showReasonDialog}
                    onClose={handleCloseReasonDialog}
                    maxWidth="sm"
                    fullWidth
                    PaperProps={{
                        sx: {
                            borderRadius: 2,
                            backgroundColor: 'white'
                        },
                    }}
                >
                    <DialogTitle sx={{ pb: 1 }}>
                        <Typography variant="h6" sx={{ fontWeight: 600, color: '#333' }}>
                            Join as Mentee
                        </Typography>
                        <Typography variant="body2" color="#757575" sx={{ mt: 1 }}>
                            Tell us why you want {mentorDetails?.name} as your mentor
                        </Typography>
                    </DialogTitle>
                    <DialogContent sx={{ pt: 2 }}>
                        <TextField
                            autoFocus
                            fullWidth
                            multiline
                            rows={4}
                            label="Why do you want an alumni mentor?"
                            placeholder="Share your goals, what you hope to learn, or how this mentorship will help your career..."
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            variant="outlined"
                            sx={{ mt: 1 }}
                            inputProps={{ maxLength: 500 }}
                            helperText={`${reason.length}/500 characters`}
                        />
                    </DialogContent>
                    <DialogActions sx={{ p: 3, pt: 1 }}>
                        <Button
                            onClick={handleCloseReasonDialog}
                            sx={{
                                textTransform: "none",
                                color: '#757575',
                                '&:hover': {
                                    backgroundColor: 'transparent'
                                }
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleSubmitReason}
                            variant="contained"
                            disabled={!reason.trim() || isSubmitting}
                            sx={{
                                textTransform: "none",
                                fontWeight: 600,
                                px: 3,
                                backgroundColor: '#028943',
                                '&:hover': {
                                    backgroundColor: '#026f35'
                                }
                            }}
                        >
                            {isSubmitting ? "Submitting..." : "Submit Request"}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Dialog>
        </>
    )
}

export default MentorDetails
